module.exports = __webpack_public_path__ + "img/2012-09_bloomberg.61f1f876.png";